var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _rect, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _g, _rect2, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCouponsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 210,
    viewBox: "0 0 190 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.37305 178.235V148.368C3.37305 146.709 4.7184 145.363 6.37793 145.363H39.0021C40.6617 145.363 42.007 146.709 42.007 148.368V178.235C42.007 179.895 40.6617 181.241 39.0021 181.241H6.37793C4.7184 181.241 3.37305 179.895 3.37305 178.235Z",
    fill: "#C9C1AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.37305 178.235V148.368C3.37305 146.709 4.7184 145.363 6.37793 145.363H39.0021C40.6617 145.363 42.007 146.709 42.007 148.368V178.235C42.007 179.895 40.6617 181.241 39.0021 181.241H6.37793C4.7184 181.241 3.37305 179.895 3.37305 178.235Z",
    stroke: "#1B1836",
    strokeWidth: 2.04893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3944 148.368C43.3944 147.973 43.3165 147.582 43.1651 147.217C43.0137 146.852 42.792 146.521 42.5123 146.241C42.2326 145.962 41.9007 145.741 41.5354 145.59C41.1702 145.44 40.7789 145.362 40.3837 145.363H5.00487C4.20793 145.363 3.44362 145.68 2.8801 146.243C2.31658 146.807 2 147.571 2 148.368V154.746H43.3944V148.368Z",
    fill: "#C9C1AE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3944 148.368C43.3944 147.973 43.3165 147.582 43.1651 147.217C43.0137 146.852 42.792 146.521 42.5123 146.241C42.2326 145.962 41.9007 145.741 41.5354 145.59C41.1702 145.44 40.7789 145.362 40.3837 145.363H5.00487C4.20793 145.363 3.44362 145.68 2.8801 146.243C2.31658 146.807 2 147.571 2 148.368V154.746H43.3944V148.368Z",
    stroke: "#1B1836",
    strokeWidth: 2.04893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8255 181.237H18.5469V154.744H26.8255V181.237Z",
    fill: "#F5EAD2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8255 181.237H18.5469V154.744H26.8255V181.237Z",
    stroke: "#650D1B",
    strokeWidth: 2.04893,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3761 154.746H17.9941V145.363H27.3761V154.746Z",
    fill: "#F5EAD2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3761 154.746H17.9941V145.363H27.3761V154.746Z",
    stroke: "#650D1B",
    strokeWidth: 2.04893,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9136 145.364C30.9136 145.364 36.2566 143.54 36.1396 141.662C36.0224 139.783 32.9756 135.263 30.2108 135.203C27.446 135.144 22.8664 145.364 22.6914 145.364H30.9136Z",
    fill: "#F5EAD2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9136 145.364C30.9136 145.364 36.2566 143.54 36.1396 141.662C36.0224 139.783 32.9756 135.263 30.2108 135.203C27.446 135.144 22.8664 145.364 22.6914 145.364H30.9136Z",
    stroke: "#650D1B",
    strokeWidth: 2.04893,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4434 145.126C30.5562 142.836 33.7274 141.309 33.7274 141.309L28.4434 145.126Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4434 145.126C30.5562 142.836 33.7274 141.309 33.7274 141.309",
    stroke: "#650D1B",
    strokeWidth: 2.04893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4667 145.364C14.4667 145.364 9.12502 143.54 9.24213 141.662C9.35927 139.783 12.4075 135.263 15.1709 135.203C17.9343 135.144 22.5139 145.364 22.6904 145.364H14.4667Z",
    fill: "#F5EAD2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4667 145.364C14.4667 145.364 9.12502 143.54 9.24213 141.662C9.35927 139.783 12.4075 135.263 15.1709 135.203C17.9343 135.144 22.5139 145.364 22.6904 145.364H14.4667Z",
    stroke: "#650D1B",
    strokeWidth: 2.04893,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9376 145.126C14.8235 142.836 11.6523 141.309 11.6523 141.309L16.9376 145.126Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9376 145.126C14.8235 142.836 11.6523 141.309 11.6523 141.309",
    stroke: "#650D1B",
    strokeWidth: 2.04893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2974 145.367C26.2316 144.455 25.823 143.603 25.1541 142.98C24.4851 142.358 23.6053 142.012 22.6917 142.012C21.778 142.012 20.8982 142.358 20.2292 142.98C19.5603 143.603 19.1518 144.455 19.0859 145.367H26.2974Z",
    fill: "#C9C1AE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2974 145.367C26.2316 144.455 25.823 143.603 25.1541 142.98C24.4851 142.358 23.6053 142.012 22.6917 142.012C21.778 142.012 20.8982 142.358 20.2292 142.98C19.5603 143.603 19.1518 144.455 19.0859 145.367H26.2974Z",
    stroke: "#650D1B",
    strokeWidth: 2.04893,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M3.2832 155.191H42.0083V157.391H3.2832V155.191Z",
    fill: "#CFCFCF"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6629 100.756L166.993 116.471C166.166 121.641 169.681 126.604 174.851 127.638L161.824 201.459L55.5371 182.642L68.5644 108.614C73.1137 108.407 76.8358 105.098 77.6629 100.756Z",
    fill: "#F5EAD2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 66.8496,
    y: 108.836,
    width: 109.553,
    height: 82.6335,
    transform: "rotate(10.1845 66.8496 108.836)",
    fill: "#F5EAD2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M187.722 51.7469L177.796 108.405C172.627 107.372 167.457 110.887 166.63 116.263L77.2997 100.548C78.1268 95.9985 75.6454 91.6561 71.5098 90.0018L81.6421 32.9297L187.722 51.7469Z",
    fill: "#FFFFF6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M187.309 55.0556C187.516 53.6081 186.689 52.1606 185.242 51.9538L83.9179 34.1705C82.4704 33.9637 81.023 34.7908 80.8162 36.2383L71.3042 89.7951C75.4398 91.4494 77.9212 95.7918 77.0941 100.341C76.267 105.097 72.5449 108.199 67.9956 108.406L54.1412 186.983C53.9344 188.431 54.7615 189.878 56.209 190.085L157.533 207.868C158.98 208.075 160.428 207.248 160.634 205.8L174.489 127.43C169.113 126.602 165.804 121.64 166.631 116.263C167.458 111.094 172.628 107.578 177.797 108.406L187.309 55.0556ZM189.377 55.4691L179.658 109.646L179.452 110.887L178.418 110.473C178.211 110.473 177.797 110.267 177.591 110.267C173.455 109.439 169.526 112.334 168.699 116.47C168.079 120.606 170.767 124.535 174.902 125.362C175.109 125.569 175.523 125.569 175.73 125.569H176.97L176.763 126.809L162.702 206.214C162.289 208.695 159.807 210.35 157.326 209.936L56.0022 192.153C53.5208 191.739 51.8666 189.258 52.2801 186.776L66.3414 107.372L66.5482 106.545H67.3753C71.0974 106.751 74.6127 104.063 75.233 100.134C75.8534 96.2054 73.5788 92.4833 69.8567 91.4494L69.0296 91.2426L69.2363 90.4154L78.7484 36.0315C79.1619 33.5501 81.6433 31.8959 84.1247 32.3094L185.448 50.0928C188.137 50.5063 189.791 52.9877 189.377 55.4691Z",
    fill: "#1B1836"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5001 109.234L102.738 68.2911C103.151 66.0164 105.219 64.569 107.494 64.9825L152.159 72.8403C154.433 73.2538 155.881 75.3217 155.467 77.5963L148.23 118.539C147.816 120.814 145.748 122.261 143.474 121.848L98.8086 113.99C96.534 113.577 95.0865 111.509 95.5001 109.234Z",
    fill: "#C9C1AE"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5001 109.234L102.738 68.2911C103.151 66.0164 105.219 64.569 107.494 64.9825L152.159 72.8403C154.433 73.2538 155.881 75.3217 155.467 77.5963L148.23 118.539C147.816 120.814 145.748 122.261 143.474 121.848L98.8086 113.99C96.534 113.577 95.0865 111.509 95.5001 109.234Z",
    stroke: "#1B1836",
    strokeWidth: 2.06783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M157.325 78.0089C157.532 77.3886 157.532 76.975 157.325 76.3547C157.325 75.9411 157.118 75.3207 156.705 74.9072C156.291 74.4936 155.878 74.08 155.464 73.8733C155.05 73.4597 154.637 73.2529 154.016 73.2529L105.629 64.7748C104.595 64.568 103.355 64.7748 102.528 65.3952C101.7 66.0155 101.08 67.0494 100.873 68.0833L99.4258 76.7682L156.084 86.6938L157.325 78.0089Z",
    fill: "#C9C1AE"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M157.325 78.0089C157.532 77.3886 157.532 76.975 157.325 76.3547C157.325 75.9411 157.118 75.3207 156.705 74.9072C156.291 74.4936 155.878 74.08 155.464 73.8733C155.05 73.4597 154.637 73.2529 154.016 73.2529L105.629 64.7748C104.595 64.568 103.355 64.7748 102.528 65.3952C101.7 66.0155 101.08 67.0494 100.873 68.0833L99.4258 76.7682L156.084 86.6938L157.325 78.0089Z",
    stroke: "#1B1836",
    strokeWidth: 2.06783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M126.928 118.956L115.555 116.888L121.965 80.4941L133.338 82.562L126.928 118.956Z",
    fill: "#61B5FF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M126.928 118.956L115.555 116.888L121.965 80.4941L133.338 82.562L126.928 118.956Z",
    stroke: "#1B1836",
    strokeWidth: 2.06783,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M133.957 82.7651L121.137 80.4905L123.411 67.6699L136.232 69.9445L133.957 82.7651Z",
    fill: "#61B5FF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M133.957 82.7651L121.137 80.4905L123.411 67.6699L136.232 69.9445L133.957 82.7651Z",
    stroke: "#1B1836",
    strokeWidth: 2.06783,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M141.195 70.5635C141.195 70.5635 149.053 69.5296 149.26 66.8414C149.467 64.1532 146.365 57.3294 142.643 56.5023C138.714 55.8819 130.029 68.7025 129.822 68.7025L141.195 70.5635Z",
    fill: "#61B5FF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M141.195 70.5635C141.195 70.5635 149.053 69.5296 149.26 66.8414C149.467 64.1532 146.365 57.3294 142.643 56.5023C138.714 55.8819 130.029 68.7025 129.822 68.7025L141.195 70.5635Z",
    stroke: "#1B1836",
    strokeWidth: 2.06783,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M137.889 69.7394C141.197 67.0512 145.953 65.8105 145.953 65.8105L137.889 69.7394Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M137.889 69.7394C141.197 67.0512 145.953 65.8105 145.953 65.8105",
    stroke: "#1B1836",
    strokeWidth: 2.06783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M118.45 66.8436C118.45 66.8436 111.627 62.9147 112.247 60.4334C112.867 57.952 118.244 52.3688 121.966 52.9892C125.688 53.6095 129.617 68.7047 129.823 68.7047L118.45 66.8436Z",
    fill: "#61B5FF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M118.45 66.8436C118.45 66.8436 111.627 62.9147 112.247 60.4334C112.867 57.952 118.244 52.3688 121.966 52.9892C125.688 53.6095 129.617 68.7047 129.823 68.7047L118.45 66.8436Z",
    stroke: "#1B1836",
    strokeWidth: 2.06783,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M122.174 67.0489C119.693 63.5336 115.764 60.6387 115.764 60.6387L122.174 67.0489Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M122.174 67.0489C119.693 63.5336 115.764 60.6387 115.764 60.6387",
    stroke: "#1B1836",
    strokeWidth: 2.06783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M134.783 69.5317C134.783 68.291 134.576 67.0503 133.749 66.0164C132.922 64.9825 131.888 64.3621 130.648 64.1554C129.407 63.9486 128.166 64.3621 127.132 64.9825C126.098 65.6028 125.478 66.6367 125.064 67.8774L134.783 69.5317Z",
    fill: "#FECC09"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M134.783 69.5317C134.783 68.291 134.576 67.0503 133.749 66.0164C132.922 64.9825 131.888 64.3621 130.648 64.1554C129.407 63.9486 128.166 64.3621 127.132 64.9825C126.098 65.6028 125.478 66.6367 125.064 67.8774L134.783 69.5317Z",
    stroke: "#1B1836",
    strokeWidth: 1.03391,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M122.38 174.578L126.723 175.405L127.55 171.062L123.208 170.235L122.38 174.578ZM125.482 156.794L130.031 157.828L129.204 162.171L124.862 161.344L124.035 165.686L119.692 164.859L120.519 160.516L116.177 159.689L117.004 155.347L121.347 156.174L120.519 160.516L124.862 161.344L125.482 156.794ZM128.377 166.306L132.72 167.133L133.547 162.791L129.204 161.964L128.377 166.306ZM114.523 168.581L118.865 169.408L119.692 165.066L115.35 164.238L114.523 168.581ZM104.184 142.733L108.526 143.56L109.353 139.218L105.011 138.391L104.184 142.733Z",
    fill: "#650D1B"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M124.241 146.455L128.584 147.075L129.411 142.732L125.068 141.905L124.241 146.455ZM100.048 145.627L111.214 147.488L113.282 136.322L102.115 134.461L100.048 145.627ZM97.3594 146.455L99.8408 132.807C99.8408 132.187 100.668 131.566 101.288 131.773L114.936 134.254C115.556 134.254 116.177 135.082 115.97 135.702L113.488 149.556C113.488 150.177 112.661 150.797 112.041 150.59L98.3933 148.109C97.7729 147.902 97.3594 147.282 97.3594 146.455Z",
    fill: "#650D1B"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M100.666 163.202L105.008 163.823L105.836 159.48L101.493 158.653L100.666 163.202ZM120.31 149.141L131.477 151.002L133.545 139.836L122.378 137.975L120.31 149.141ZM117.622 150.175L120.104 136.321C120.104 135.7 120.931 135.08 121.551 135.287L135.199 137.768C135.819 137.768 136.439 138.595 136.233 139.216L133.751 153.07C133.751 153.69 132.924 154.311 132.304 154.104L118.656 151.623C117.829 151.416 117.415 150.795 117.622 150.175Z",
    fill: "#650D1B"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M109.766 156.794L98.5993 154.933L96.5315 166.1L107.698 167.961L109.766 156.794ZM112.454 155.76L109.972 169.615C109.972 170.235 109.145 170.856 108.525 170.649L94.8772 168.167C94.2569 168.167 93.6365 167.34 93.8433 166.72L96.3247 152.865C96.3247 152.245 97.1518 151.625 97.7722 151.832L111.42 154.313C112.247 154.52 112.661 155.14 112.454 155.76Z",
    fill: "#650D1B"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1133 130.738L89.4962 168.786C89.0826 171.061 90.5301 173.129 92.8047 173.542L130.646 180.159C132.921 180.573 134.988 179.126 135.402 176.851L142.019 138.803C142.433 136.528 140.985 134.46 138.711 134.047L100.869 127.43C98.5946 127.016 96.5268 128.464 96.1133 130.738Z",
    stroke: "#650D1B",
    strokeWidth: 2.06783,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M114.521 129.706L124.654 131.567L121.139 126.397C120.725 125.983 120.105 125.777 119.691 126.19L114.521 129.706Z",
    fill: "#650D1B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2029_12239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.811 89.794C149.468 90.8279 146.366 94.7568 146.366 99.306C146.366 103.855 149.468 107.784 153.811 108.818C155.258 109.025 156.085 110.266 156.085 111.713V181.399C156.085 183.053 154.845 184.294 153.19 184.294H51.0395C49.3852 184.294 48.1445 183.053 48.1445 181.399V111.093C48.1445 109.852 48.9717 108.818 50.0056 108.404C53.5209 106.75 55.7955 103.442 55.7955 99.5128C55.7955 95.5839 53.3141 92.0686 50.0056 90.6211C48.9717 90.2076 48.1445 89.1737 48.1445 87.933V34.9965C48.1445 33.3423 49.3852 32.1016 51.0395 32.1016H153.19C154.845 32.1016 156.085 33.3423 156.085 34.9965V86.8991C156.085 88.3465 155.258 89.5872 153.811 89.794Z",
    fill: "black"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 41.0391,
    y: 104.732,
    width: 109.309,
    height: 80.3084,
    fill: "#F5EAD2"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5924 93.1035H140.163C140.163 98.4799 144.506 102.822 149.882 102.822V177.885H41.9414V102.616C46.2838 101.582 49.5924 97.6527 49.5924 93.1035Z",
    fill: "#F5EAD2"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M149.88 25.8984V83.5909C144.504 83.5909 140.161 87.9333 140.161 93.3097H49.3836C49.3836 88.5537 46.2819 84.8316 41.9395 83.7977V25.8984H149.88Z",
    fill: "#FFFFF6"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M149.883 29.2094C149.883 27.7619 148.643 26.5212 147.195 26.5212H44.424C42.9765 26.5212 41.7358 27.7619 41.7358 29.2094V83.5933C46.0782 84.6272 49.3868 88.3493 49.3868 93.1053C49.3868 97.8613 46.0782 101.583 41.7358 102.617V182.229C41.7358 183.676 42.9765 184.917 44.424 184.917H147.195C148.643 184.917 149.883 183.676 149.883 182.229V102.824C144.507 102.824 140.164 98.4817 140.164 93.1053C140.164 87.729 144.507 83.3865 149.883 83.3865V29.2094ZM151.951 29.2094V84.4204V85.6611L150.71 85.4543C150.504 85.4543 150.09 85.4543 149.883 85.4543C145.541 85.4543 142.232 88.9697 142.232 93.1053C142.232 97.241 145.748 100.756 149.883 100.756C150.09 100.756 150.504 100.756 150.71 100.756L151.951 100.55V101.79V182.436C151.951 185.124 149.883 187.192 147.195 187.192H44.424C41.7358 187.192 39.668 185.124 39.668 182.436V101.79V100.963L40.4951 100.756C44.2172 100.343 47.1122 97.0342 47.1122 93.1053C47.1122 89.1764 44.2172 85.8679 40.4951 85.4543L39.668 85.2476V84.4204V29.4162C39.668 26.728 41.7358 24.6602 44.424 24.6602H147.402C149.883 24.6602 151.951 26.728 151.951 29.2094Z",
    fill: "#1B1836"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0293 98.4803V56.9169C69.0293 54.6423 70.8903 52.7812 73.165 52.7812H118.45C120.725 52.7812 122.586 54.6423 122.586 56.9169V98.4803C122.586 100.755 120.725 102.616 118.45 102.616H73.165C70.8903 102.616 69.0293 100.755 69.0293 98.4803Z",
    fill: "#C9C1AE"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0293 98.4803V56.9169C69.0293 54.6423 70.8903 52.7812 73.165 52.7812H118.45C120.725 52.7812 122.586 54.6423 122.586 56.9169V98.4803C122.586 100.755 120.725 102.616 118.45 102.616H73.165C70.8903 102.616 69.0293 100.755 69.0293 98.4803Z",
    stroke: "#1B1836",
    strokeWidth: 2.06783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M124.655 56.9167C124.655 56.2963 124.449 55.676 124.242 55.2624C124.035 54.642 123.828 54.2285 123.415 53.8149C123.001 53.6081 122.381 53.1946 121.967 52.9878C121.347 52.781 120.933 52.5742 120.313 52.5742H71.0986C70.0646 52.5742 69.0307 53.1946 68.2036 53.8149C67.3765 54.4353 66.9629 55.676 66.9629 56.7099V65.6015H124.655V56.9167Z",
    fill: "#C9C1AE"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M124.655 56.9167C124.655 56.2963 124.449 55.676 124.242 55.2624C124.035 54.642 123.828 54.2285 123.415 53.8149C123.001 53.6081 122.381 53.1946 121.967 52.9878C121.347 52.781 120.933 52.5742 120.313 52.5742H71.0986C70.0646 52.5742 69.0307 53.1946 68.2036 53.8149C67.3765 54.4353 66.9629 55.676 66.9629 56.7099V65.6015H124.655V56.9167Z",
    stroke: "#1B1836",
    strokeWidth: 2.06783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M101.496 102.409H89.916V65.6016H101.496V102.409Z",
    fill: "#F5EAD2"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M101.496 102.409H89.916V65.6016H101.496V102.409Z",
    stroke: "#650D1B",
    strokeWidth: 2.06783,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M102.322 65.6015H89.2949V52.5742H102.322V65.6015Z",
    fill: "#F5EAD2"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M102.322 65.6015H89.2949V52.5742H102.322V65.6015Z",
    stroke: "#650D1B",
    strokeWidth: 2.06783,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M107.488 52.5771C107.488 52.5771 114.932 50.0957 114.725 47.4076C114.519 44.9262 110.383 38.5159 106.454 38.5159C102.525 38.3091 96.115 52.5771 95.9082 52.5771H107.488Z",
    fill: "#F5EAD2"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M107.488 52.5771C107.488 52.5771 114.932 50.0957 114.725 47.4076C114.519 44.9262 110.383 38.5159 106.454 38.5159C102.525 38.3091 96.115 52.5771 95.9082 52.5771H107.488Z",
    stroke: "#650D1B",
    strokeWidth: 2.06783,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M103.77 52.3686C106.871 49.06 111.214 46.9922 111.214 46.9922L103.77 52.3686Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M103.77 52.3686C106.871 49.06 111.214 46.9922 111.214 46.9922",
    stroke: "#650D1B",
    strokeWidth: 2.06783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3334 52.5771C84.3334 52.5771 76.8892 50.0957 77.096 47.4076C77.3028 44.9262 81.4385 38.5159 85.3673 38.5159C89.2962 38.3091 95.7065 52.5771 95.9133 52.5771H84.3334Z",
    fill: "#F5EAD2"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3334 52.5771C84.3334 52.5771 76.8892 50.0957 77.096 47.4076C77.3028 44.9262 81.4385 38.5159 85.3673 38.5159C89.2962 38.3091 95.7065 52.5771 95.9133 52.5771H84.3334Z",
    stroke: "#650D1B",
    strokeWidth: 2.06783,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8465 52.3686C84.7448 49.06 80.4023 46.9922 80.4023 46.9922L87.8465 52.3686Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8465 52.3686C84.7448 49.06 80.4023 46.9922 80.4023 46.9922",
    stroke: "#650D1B",
    strokeWidth: 2.06783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M101.079 52.5744C100.873 51.3337 100.459 50.093 99.4251 49.2658C98.3912 48.2319 97.1505 47.8184 95.9098 47.8184C94.4623 47.8184 93.4284 48.4387 92.3945 49.2658C91.3606 50.093 90.7402 51.3337 90.7402 52.5744H101.079Z",
    fill: "#C9C1AE"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M101.079 52.5744C100.873 51.3337 100.459 50.093 99.4251 49.2658C98.3912 48.2319 97.1505 47.8184 95.9098 47.8184C94.4623 47.8184 93.4284 48.4387 92.3945 49.2658C91.3606 50.093 90.7402 51.3337 90.7402 52.5744H101.079Z",
    stroke: "#650D1B",
    strokeWidth: 2.06348,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M106.868 158.238H111.417V153.689H106.868V158.238ZM106.868 140.041H111.417V144.59H106.868V149.14H102.526V144.59H97.9765V140.041H102.526V144.59H106.868V140.041ZM111.211 149.14H115.76V144.59H111.211V149.14ZM97.9765 153.689H102.526V149.14H97.9765V153.689ZM83.2949 130.116H87.8441V125.566H83.2949V130.116Z",
    fill: "#650D1B"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M103.769 130.118H108.318V125.569H103.769V130.118ZM79.989 133.427H91.362V122.054H79.989V133.427ZM77.3008 134.874V120.813C77.3008 120.193 77.9211 119.572 78.5415 119.572H92.3959C93.0163 119.572 93.6366 120.193 93.6366 120.813V134.874C93.6366 135.495 93.0163 136.115 92.3959 136.115H78.5415C77.9211 136.115 77.3008 135.495 77.3008 134.874Z",
    fill: "#650D1B"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2949 150.796H87.8441V146.247H83.2949V150.796ZM100.251 133.427H111.624V122.054H100.251V133.427ZM97.7697 134.874V120.813C97.7697 120.193 98.3901 119.572 99.0104 119.572H112.865C113.485 119.572 114.106 120.193 114.106 120.813V134.874C114.106 135.495 113.485 136.115 112.865 136.115H99.0104C98.3901 136.115 97.7697 135.495 97.7697 134.874Z",
    fill: "#650D1B"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3642 154.106V142.733H79.9912V154.106H91.1574H91.3642ZM93.8456 141.286V155.347C93.8456 155.967 93.2253 156.588 92.6049 156.588H78.7505C78.1301 156.588 77.5098 155.967 77.5098 155.347V141.286C77.5098 140.665 78.1301 140.045 78.7505 140.045H92.6049C93.2253 140.045 93.8456 140.665 93.8456 141.286Z",
    fill: "#650D1B"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M73.166 119.571V158.24C73.166 160.514 75.0271 162.375 77.3017 162.375H115.763C118.038 162.375 119.899 160.514 119.899 158.24V119.571C119.899 117.297 118.038 115.436 115.763 115.436H77.3017C75.0271 115.436 73.166 117.297 73.166 119.571Z",
    stroke: "#650D1B",
    strokeWidth: 2.06783,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3652 115.438H101.704L97.1552 110.888C96.7416 110.475 96.1212 110.475 95.7077 110.888L91.3652 115.438Z",
    fill: "#650D1B"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M185.787 34.1158C183.055 41.5639 175.656 39.0845 175.656 39.0845C181.304 37.7162 180.541 31.6094 179.121 30.6304L184.579 26.5723C184.579 26.5723 187.575 29.2476 185.787 34.1158Z",
    fill: "#F5EAD2"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M185.787 34.1158C183.055 41.5639 175.656 39.0845 175.656 39.0845C181.304 37.7162 180.541 31.6094 179.121 30.6304L184.579 26.5723C184.579 26.5723 187.575 29.2476 185.787 34.1158Z",
    stroke: "#650D1B",
    strokeWidth: 1.02447,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5665 10.9157C18.8625 11.0298 14.5092 10.553 12.4326 8.37109C10.9479 9.46113 7.88086 9.94734 7.88086 9.94734C12.4326 15.5227 18.2704 10.8017 18.5665 10.9157Z",
    fill: "#C9C1AE"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5665 10.9157C18.8625 11.0298 14.5092 10.553 12.4326 8.37109C10.9479 9.46113 7.88086 9.94734 7.88086 9.94734C12.4326 15.5227 18.2704 10.8017 18.5665 10.9157Z",
    stroke: "#1B1836",
    strokeWidth: 1.02447,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89793 56.356C11.0135 56.148 17.1342 51.5918 17.1342 51.5918C17.1342 51.5918 16.0175 56.8444 12.1691 59.9404C8.32079 63.0363 2.1543 62.2629 2.1543 62.2629C5.67377 60.9333 6.89793 56.356 6.89793 56.356Z",
    fill: "#F5EAD2"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89793 56.356C11.0135 56.148 17.1342 51.5918 17.1342 51.5918C17.1342 51.5918 16.0175 56.8444 12.1691 59.9404C8.32079 63.0363 2.1543 62.2629 2.1543 62.2629C5.67377 60.9333 6.89793 56.356 6.89793 56.356Z",
    stroke: "#650D1B",
    strokeWidth: 1.02447,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M45.698 9.84501C45.698 9.84501 44.4951 11.3226 40.6476 13.9083C40.6476 9.24106 34.998 5.76511 34.998 5.76511L40.1669 1C45.0966 3.58205 45.698 9.84501 45.698 9.84501Z",
    fill: "#F5EAD2"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M45.698 9.84501C45.698 9.84501 44.4951 11.3226 40.6476 13.9083C40.6476 9.24106 34.998 5.76511 34.998 5.76511L40.1669 1C45.0966 3.58205 45.698 9.84501 45.698 9.84501Z",
    stroke: "#650D1B",
    strokeWidth: 1.02447,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M181.832 59.5994C182.424 59.7673 173.718 59.0527 169.564 55.7812C166.595 57.4184 160.461 58.1445 160.461 58.1445C164.794 62.1249 169.71 62.6076 173.736 62.0386C178.168 61.4122 181.522 59.5114 181.832 59.5994Z",
    fill: "#C9C1AE"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M181.832 59.5994C182.424 59.7673 173.718 59.0527 169.564 55.7812C166.595 57.4184 160.461 58.1445 160.461 58.1445C164.794 62.1249 169.71 62.6076 173.736 62.0386C178.168 61.4122 181.522 59.5114 181.832 59.5994Z",
    stroke: "#1B1836",
    strokeWidth: 1.02447,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M136.889 5.42923C137.306 5.54131 131.211 5.06472 128.301 2.88281C126.224 3.97469 121.93 4.45885 121.93 4.45885C128.301 10.0322 136.473 5.31715 136.889 5.42923Z",
    fill: "#C9C1AE"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M136.889 5.42923C137.306 5.54131 131.211 5.06472 128.301 2.88281C126.224 3.97469 121.93 4.45885 121.93 4.45885C128.301 10.0322 136.473 5.31715 136.889 5.42923Z",
    stroke: "#1B1836",
    strokeWidth: 1.02447,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2029_12239",
    x: 44.7983,
    y: 28.7554,
    width: 114.634,
    height: 158.884,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.67309,
    result: "effect1_foregroundBlur_2029_12239"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponsIcon);
export default __webpack_public_path__ + "static/media/couponsIcon.80ebc32443e0bd209b70e5074a32bbcf.svg";
export { ForwardRef as ReactComponent };